import type { ReactNode } from 'react';
import React from 'react';

import type { IUniversalSelectOption } from '@feathr/components';

/* UniversalSelect calls this for both the menu rows and the selected value. */
export function formatTypefaceOptionLabel({ id, name }: IUniversalSelectOption): ReactNode {
  return <span style={{ fontFamily: id }}>{name}</span>;
}
